if (!customElements.get('cart-reservation-timer')) {
  customElements.define('cart-reservation-timer', class CartReservationTimer extends HTMLElement {
    constructor() {
      super();
      this.STORAGE_KEY = 'shopify_cart_reservation_expiry';
      this.timerInterval = null;
    }

    connectedCallback() {
      this.durationMinutes = parseInt(this.dataset.durationMinutes || 10, 10);
      this.textContainer = this.querySelector('[data-cart-reservation-text]');
      this.timerEl = this.querySelector('[data-cart-reservation-timer]');

      this.initTimer();
      this.bindEvents();
    }

    disconnectedCallback() {
      this.stopTimer();
      this.unbindEvents();
    }

    bindEvents() {
      this.onCartUpdate = () => this.checkCartItemCount();
      document.addEventListener('cart-updated', this.onCartUpdate);
      document.addEventListener('theme:cart:refresh', this.onCartUpdate);
    }

    unbindEvents() {
      document.removeEventListener('cart-updated', this.onCartUpdate);
      document.removeEventListener('theme:cart:refresh', this.onCartUpdate);
    }

    initTimer() {
      if (this.hasAttribute('hidden') || this.style.display === 'none') {
        this.clearStorage();
        return;
      }

      let expiryTimestamp = sessionStorage.getItem(this.STORAGE_KEY);
      const now = Date.now();

      if (!expiryTimestamp || parseInt(expiryTimestamp, 10) <= now) {
        expiryTimestamp = now + this.durationMinutes * 60 * 1000;
        sessionStorage.setItem(this.STORAGE_KEY, expiryTimestamp);
      } else {
        expiryTimestamp = parseInt(expiryTimestamp, 10);
      }

      this.expiryTimestamp = expiryTimestamp;

      this.stopTimer();
      this.updateTimerDisplay();
      this.timerInterval = setInterval(() => this.updateTimerDisplay(), 1000);
    }

    updateTimerDisplay() {
      const now = Date.now();
      const distance = this.expiryTimestamp - now;

      if (distance <= 0) {
        if (this.textContainer) {
          this.textContainer.textContent = 'Your reservation has expired — items may sell out';
        }
        this.classList.remove('is-warning');
        this.stopTimer();
        
        sessionStorage.removeItem(this.STORAGE_KEY);
        return;
      }

      if (distance < 60000) {
        this.classList.add('is-warning');
      } else {
        this.classList.remove('is-warning');
      }

      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      const formattedMinutes = String(minutes).padStart(2, '0');
      const formattedSeconds = String(seconds).padStart(2, '0');

      if (this.timerEl) {
        this.timerEl.textContent = `${formattedMinutes}:${formattedSeconds}`;
      } else if (this.textContainer) {
        this.textContainer.innerHTML = `Your cart is reserved for <strong data-cart-reservation-timer>${formattedMinutes}:${formattedSeconds}</strong> minutes`;
        this.timerEl = this.querySelector('[data-cart-reservation-timer]');
      }
    }

    stopTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
    }

    clearStorage() {
      this.stopTimer();
      sessionStorage.removeItem(this.STORAGE_KEY);
    }

    async checkCartItemCount() {
      try {
        const rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        const res = await fetch(rootUrl + 'cart.js');
        if (!res.ok) return;

        const cart = await res.json();

        if (cart.item_count === 0) {
          this.clearStorage();
          this.setAttribute('hidden', '');
        } else {
          this.removeAttribute('hidden');
          this.initTimer();
        }
      } catch (err) {
        console.error('Error checking cart state:', err);
      }
    }
  });
}